import { render } from "./ConfiguracaoUnidade.vue?vue&type=template&id=72bc531b&scoped=true"
import script from "./ConfiguracaoUnidade.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoUnidade.vue?vue&type=script&lang=js"

import "./ConfiguracaoUnidade.vue?vue&type=style&index=0&id=72bc531b&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bc531b"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QToggle,QSelect,QInput,QDialog,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
